import React from 'react';
import DataTable from "../../components/data-table/DataTable";
import {getCheckingAccounts, navLinks} from "../../services/organization";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import SearchField from "../../components/fields/SearchField";
import ActionButton from "../../components/button/ActionButton";

const columnData = [
    { id: 'bankName', numeric: false, disablePadding: false, label: 'Название банка' },
    { id: 'juridicalPersonShortName', numeric: false, disablePadding: false, label: 'Юридическое лицо' },
    { id: 'rs', numeric: false, disablePadding: false, label: 'Р/С' },
    { id: 'kr', numeric: false, disablePadding: false, label: 'К/С' },
    { id: 'bik', numeric: false, disablePadding: false, label: 'БИК' },
    { id: 'currency', label: 'Валюта'},
    { id: 'active', label: 'Active'}
];

class CheckingAccountListPage extends React.Component {

    state = {
        search: {
            search: null
        },
        refreshTable: false
    };

    handleChange = prop => event => {
        this.setState({
            search: {
                ...this.state.search,
                [prop]: event.target.value,
            }
        });
    };

    handleClickSearch = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    handleAdd = () => {
        this.props.history.push(`/organization/checking-accounts/view/0`);
    };

    getTableData = (...params) => {
        const {search} = this.state;
        return getCheckingAccounts(search, ...params);
    };

    render() {
        const { search, refreshTable } = this.state;

        return (
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <SearchField
                        value={search.search}
                        onChange={this.handleChange('search')}
                        onClick={this.handleClickSearch}
                        label="Поиск"
                    />
                    <br />
                    <br />
                    <ActionButton onClick={this.handleAdd}>Добавить</ActionButton>
                </LeftBar>
                <Content title="Расчетные счета">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        linkTemplate={(item) => `/organization/checking-accounts/view/${item.id}`}
                        selector={false}
                        refresh={refreshTable}
                    />
                </Content>
            </React.Fragment>
        );
    }
}

export default CheckingAccountListPage;
